import { TextField as TextFieldWrapper, styled } from '@mui/material';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';

import styles from '../../../ui/form-elements/PhoneField/PhoneField.module.sass';
import { IField } from '../../../ui/form-elements/form-element.inrerface';

import './CheckoutAddressField.sass';

// Кастомный стиль инпута телефона
const CssTextField = styled(TextFieldWrapper)({
  '& label.Mui-focused': {
    color: '#949494',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      border: '1px solid #D7DDE9',
    },
    '&:hover fieldset': {
      border: '1px solid #D7DDE9',
    },
    '&.Mui-focused fieldset': {
      border: '1px solid #D7DDE9',
    },
  },
});

// Инпут оформления заказа
const CheckoutAddressField = forwardRef<HTMLInputElement, IField>(
  ({ label, name, error, ...rest }, ref) => {
    const {
      formState: { errors },
      register,
    } = useFormContext();
    return (
      <div className="address__wrapper">
        <CssTextField
          ref={ref}
          {...rest}
          className="address__input"
          label={label}
          size="small"
          color="info"
          variant="filled"
          fullWidth
        />{' '}
        {name && errors && errors[name] && (
          <div className={styles.error}>{`${
            // @ts-ignore
            errors[name].message
          }`}</div>
        )}
      </div>
    );
  }
);

CheckoutAddressField.displayName = 'CheckoutAddressField';

export default CheckoutAddressField;
